import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeIn, GoldBar } from "@/components/site/Animations";

export function ContactBanner() {
  return (
    <section
      className="bg-[hsl(218,60%,10%)] text-white"
      data-testid="contact-banner"
    >
      <div className="max-w-[1240px] mx-auto px-5 sm:px-6 lg:px-8 py-14 lg:py-16">
        <FadeIn>
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <GoldBar className="mb-5" />
              <h2
                className="text-2xl sm:text-3xl font-semibold tracking-tight mb-2"
                style={{ fontFamily: 'var(--font-display)' }}
              >
                Ready to discuss your program requirements?
              </h2>
              <p className="text-sm sm:text-base text-white/70 max-w-lg">
                Cortes Industries supports complex procurement environments and mission-critical programs. Contact us to explore how we can support your objectives.
              </p>
            </div>
            <Link
              to="/contact"
              data-testid="contact-banner-cta"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold bg-[hsl(41,47%,61%)] text-[hsl(218,60%,10%)] rounded-md hover:bg-[hsl(41,47%,66%)] transition-all btn-press shrink-0"
            >
              Contact Cortes Industries
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
